import { render } from "./OrderInfo.vue?vue&type=template&id=d9f58102&ts=true"
import script from "./OrderInfo.vue?vue&type=script&lang=ts"
export * from "./OrderInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__